module.exports = __webpack_public_path__ + "img/wallet_02_qris_3.8a6eab5b.png";